import { HL_MARKET_SLIPPAGE } from "./constants/config"

export type EntryOrder =
  | { type: "market"; markPrice: number }
  | { type: "limit"; limitPrice: number }

export function getEntryOrderPrice(order: EntryOrder): number {
  return order.type === "limit" ? order.limitPrice : order.markPrice
}

export function getEntryOrderInputError(order: EntryOrder): string | null {
  const price = getEntryOrderPrice(order)
  if (Number.isFinite(price) && price > 0) {
    return null
  }

  return order.type === "limit" ? "Enter limit price" : "Loading price"
}

export function getEntryOrderSubmissionPrice(
  order: EntryOrder,
  isLong: boolean
): number {
  if (order.type === "limit") {
    return order.limitPrice
  }

  return isLong
    ? order.markPrice * (1 + HL_MARKET_SLIPPAGE)
    : order.markPrice * (1 - HL_MARKET_SLIPPAGE)
}

export function getEntryOrderTimeInForce(order: EntryOrder): "Ioc" | "Gtc" {
  return order.type === "limit" ? "Gtc" : "Ioc"
}
